<template>
  <!--创建店铺-->
  <div class="my_shop">
    <!--<van-notice-bar :text="$t('shop.fill_shop_information')"/>-->
    <van-form @submit="onSubmit">
      <p class="my_shop_title">{{$t('shop.Shop_name')}}</p>
      <van-field class="my_shop_input" v-model="shop_name" :placeholder="$t('shop.Please_fill_shop_name')" :rules="[{ required: true}]"
      />
      <van-field name="shop_logo" :label="$t('shop.Store_logo')" class="my_shop_logo_title">
        <template #input>
          <van-col span="24" class="my_shop_information">
            <van-image round width="7em" height="7em" :src="shop_logo_url" fit="cover" v-if="shop_logo_url" @click="img_upload('img')"/>
            <img src="../assets/img/shop_img.png" class="shop2" @click="img_upload('img')" v-else>
          </van-col>
        </template>
      </van-field>
      <div>
        <van-button class="shop_button" type="primary" round block native-type="submit">{{ $t('shop.Apply_open_small_shop') }}</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
    import axios from "axios";
    import {Dialog, Toast, Uploader} from 'vant'
    import { judgeIosAndroid } from '@/assets/js/models.js'
    export default {
        name: "create_shop",
        data() {
            return {
                status: '-1',
                shop_name: '',
                shop_logo_url: '',//存上传后的图片url
            }
        },
        created: function () {
          // 创建店铺
          document.title = this.$t('shop.Create_shop_title');
          this.convert()
        },
        components: {
          [Uploader.name]: Uploader
        },
        mounted() {
          // 将要给原生调用的方法挂载到 window 上面
          window.getValueFromApp = this.getValueFromApp
        },
        methods: {
          convert() {
            const uid = this.$route.query.uid
            const token = this.$route.query.token
            axios.get(this.baseUrlApi + "mapi/public/index.php/api/shop_api/get_shop",{ params:{ uid:uid,token:token,page: this.page }}).then(res => {
              console.log(res.data);
              if (res.data.code == 1) {
                this.status = res.data.data ? res.data.data.status : '-1'
                this.shop_name = res.data.data ? res.data.data.shop_name : ''
                this.shop_logo_url = res.data.data ? res.data.data.shop_logo_url : ''
              }
            })
          },
          img_upload (name) {
            // 上传头像
            this.mobile_intercept(name)
          },
          mobile_intercept(name) {
            //  拦截
            const isIos = judgeIosAndroid();
            if (isIos == true) {
              // ios传值方法postMessage（val）传值方式
              window.webkit.messageHandlers.upload_avatar.postMessage(name)
            } else {
              // 安卓传值方法goSubmitted（val）传值方式
              window.AndroidJs.upload_avatar(name)
            }
          },
          getValueFromApp(name,url) {
            // 上传回调
            // 下载完成回调(ios和android调用接口)
            this.shop_logo_url = url
          },
          onSubmit() {
              if (this.status !== '-1') {
                let title= ''
                if (this.status === 0) {
                  title = this.$t('shop.application_under_review')
                } else if (this.status === 2) {
                  title = this.$t('shop.Audit_failure')
                } else {
                  title = this.$t('shop.is_Upload_product')
                }
                Dialog.alert({
                  message: title,
                  confirmButtonText: this.$t('btn.submit'),
                }).then(() => {
                  if (this.status === 1) {
                    this.shopManage()
                  } else {
                    this.intercept()
                  }
                });
              }else{
                const uid = this.$route.query.uid;
                const token = this.$route.query.token;
                axios.get(this.baseUrlApi + "mapi/public/index.php/api/shop_api/request_open_shop",
                  {
                    params: {
                      uid: uid,
                      token: token,
                      shop_logo_url: this.shop_logo_url,
                      shop_name: this.shop_name,
                    }
                  }).then(res => {
                  console.log(res.data);
                  Toast(res.data.msg);
                  if (res.data.code === 1) {
                    this.intercept()
                    setTimeout(() =>{
                      window.location.reload();
                    },3000)
                  }
                });
              }
          },
          intercept() {
            window.location.href="bogo://vue_shop_href";
          },
          shopManage() {
            const uid = this.$route.query.uid;
            const token = this.$route.query.token;
            // 跳转上传页面
            //this.$router.push({path:'/shopManage',query:{uid:uid, token: token }})
            this.$router.push({path: '/shopList', query: {uid: uid, token: token}})
          }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/create_shop.vue